import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusChipAvatar], [chip-avatar]',
})
export class ChipAvatarDirective {
  @HostBinding('class')
  defaultClasses = ['chip-avatar'];
}
